<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Independence Declaration</h5>
  </div>

<div  class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="card shadow">
          <div class="card-body align-items-start">
            <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="PostAssignClick()">
              Post Assignment Declaration
            </div>
        </div>
        </div>
      </div>
  
      <div class="col-md-6">
          <div class="card shadow">
            <div class="card-body align-items-start">
              <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="clientDeclaClick()">
                New Client Declaration
              </div>
          </div>
          </div>
      </div>
    </div>


    <!-- <div style="color:#007bff; text-decoration:underline; cursor:pointer">
      <div class="shadow p-3 mb-4 mt-1 bg-white rounded" (click)="PostAssignClick()">
        <h6>Post Assignment Declaration</h6>
      </div>
    </div>

    <div style="color:#007bff; text-decoration:underline; cursor:pointer">
      <div
        class="shadow p-3 mb-4 bg-white rounded"
        (click)="clientDeclaClick()"
      >
      <h6>New Client Declaration</h6>
      </div>
    </div> -->

    <div class="row pt-4">
      <div class="col-md-6">
        <div class="card shadow">
          <div class="card-body align-items-start">
            <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="employeeJoinClick()">
              Employee Joining Declaration
            </div>
        </div>
        </div>
    </div>
  
      <div class="col-md-6">
        <div class="card shadow">
          <div class="card-body align-items-start">
            <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="annualDeclaClick()">
              Annual Declaration
            </div>
        </div>
        </div>
    </div>
    </div>

    <div class="row pt-4">
      <div class="col-md-6">
        <div class="card shadow">
          <div class="card-body align-items-start">
            <div style="color: #800000; text-decoration: underline; cursor: pointer;font-size:16px;" (click)="dpdpDeclarationClick()">
              DPDP Declaration
            </div>
        </div>
        </div>
    </div>
    </div>


<!-- 
    <div style="color:#007bff; text-decoration:underline; cursor:pointer">
      <div
        class="shadow p-3 mb-4 bg-white rounded"
        (click)="employeeJoinClick()"
      >
      <h6>Employee Joining Declaration</h6>
      </div>
    </div>

    <div style="color:#007bff; text-decoration:underline; cursor:pointer">
      <div
        class="shadow p-3 mb-4 bg-white rounded"
        (click)="annualDeclaClick()"
      >
      <h6>Annual Declaration</h6>
      </div>
    </div> -->
  </div>
</div>
</div>
